import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=9223f17e&scoped=true&"
import script from "./FrontPage.vue?vue&type=script&lang=js&"
export * from "./FrontPage.vue?vue&type=script&lang=js&"
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=9223f17e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9223f17e",
  null
  
)

export default component.exports